module.exports = __webpack_public_path__ + "img/restaurantVersion.0c32e865.jpg";